module.exports = __webpack_public_path__ + "static/media/file.58208794.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/file.svg
// module id = 262
// module chunks = 3